import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-lg text-sm font-semibold transition-colors disabled:opacity-50',
  {
    variants: {
      variant: {
        navy: 'bg-[#1A2230] text-white hover:bg-[#1A2230]',
        orange: 'bg-[#E8622A] text-white hover:bg-[#E8622A]',
        outline: 'border border-[#d1d5db] bg-white text-[#1A2230]',
        ghost: 'bg-transparent text-[#6b7280]',
      },
      size: {
        ask: 'h-12 w-full px-4',
        default: 'h-10 px-4',
      },
    },
    defaultVariants: { variant: 'navy', size: 'default' },
  },
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
  },
)
Button.displayName = 'Button'

export { Button, buttonVariants }
